import {
  CHAIN_NAMESPACES,
  UX_MODE,
  WALLET_ADAPTERS,
  WEB3AUTH_NETWORK,
} from "@web3auth/base";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import { Web3AuthOptions } from "@web3auth/modal";
import { AuthAdapter } from "@web3auth/auth-adapter";

const clientId = import.meta.env.VITE_WEB_3_AUTH_CLIENT_ID;
const rpcEthSepolia = import.meta.env.VITE_WEB_3_AUTH_RPC_ETH_SEPOLIA;

export const chainConfig = {
  chainNamespace: CHAIN_NAMESPACES.EIP155,
  chainId: "0xaa36a7",
  rpcTarget: rpcEthSepolia,
  // Avoid using public rpcTarget in production.
  // Use services like Infura, Quicknode etc
  displayName: "Ethereum Sepolia Testnet",
  blockExplorerUrl: "https://sepolia.etherscan.io",
  ticker: "ETH",
  tickerName: "Ethereum",
  logo: "https://cryptologos.cc/logos/ethereum-eth-logo.png",
};

const privateKeyProvider = new EthereumPrivateKeyProvider({
  config: {
    chainConfig,
  },
});

const web3AuthOptions: Web3AuthOptions = {
  chainConfig,
  clientId,
  web3AuthNetwork: WEB3AUTH_NETWORK.SAPPHIRE_DEVNET,
  privateKeyProvider,
};

const web3AuthContextConfig = {
  web3AuthOptions,
  adapters: [
    new AuthAdapter({
      adapterSettings: {
        uxMode: UX_MODE.POPUP,
        loginConfig: {
          jwt: {
            verifier:
              import.meta.env.VITE_W3A_TELEGRAM_VERIFIER_NAME ||
              "w3a-telegram-oauth-demo",
            typeOfLogin: "jwt",
            clientId,
          },
        },
      },
    }),
  ],
  modalConfig: {
    [WALLET_ADAPTERS.AUTH]: {
      label: "auth",
      loginMethods: {
        // Enable the following login methods
        google: {
          name: "google",
          showOnModal: true,
        },
        email_passwordless: {
          name: "email_passwordless",
          showOnModal: true,
        },
        // Disable the following login methods
        facebook: {
          name: "facebook",
          showOnModal: false,
        },
        reddit: {
          name: "reddit",
          showOnModal: false,
        },
        discord: {
          name: "discord",
          showOnModal: false,
        },
        twitch: {
          name: "twitch",
          showOnModal: false,
        },
        apple: {
          name: "apple",
          showOnModal: false,
        },
        line: {
          name: "line",
          showOnModal: false,
        },
        github: {
          name: "github",
          showOnModal: false,
        },
        kakao: {
          name: "kakao",
          showOnModal: false,
        },
        linkedin: {
          name: "linkedin",
          showOnModal: false,
        },
        twitter: {
          name: "twitter",
          showOnModal: false,
        },
        weibo: {
          name: "weibo",
          showOnModal: false,
        },
        wechat: {
          name: "wechat",
          showOnModal: false,
        },
        farcaster: {
          name: "farcaster",
          showOnModal: false,
        },
        sms_passwordless: {
          name: "sms_passwordless",
          showOnModal: false,
        },
      },
    },
  },
};

export default web3AuthContextConfig;
